import Text from '../atoms/Text';
import FallbackImage from '../atoms/Image/Fallback';
import { useNavigate } from 'react-router-dom';
import { onTokenScan } from '../helpers/addressUtils';

interface IProps {
  long_title?: string;
  slug: string;
  address: string;
  chain: string;
  logo_url: string;
  onCopyAddress?: () => void;
  title: string;
  isCEX?: boolean;
}

const format_contract = (contract: string) =>
  `${contract.slice(0, 6)}...${contract.slice(contract.length - 4)}`;

const FallbackCoinIcon = ({ name }: any) => (
  <div className='logo__fallback'>{name[0]}</div>
);

const InfoCoin = (props: IProps) => {
  const navigate = useNavigate();

  const onLogoClick = () => {
    if (props.chain) {
      navigate(`/en/token/${props.chain}/${props.address}`);
    }
  };

  return (
    <div className='info_coin'>
      <div
        className={`row ${props.chain ? 'clickable' : ''}`}
        onClick={onLogoClick}
      >
        {props.logo_url ? (
          <FallbackImage
            className='logo'
            size='l'
            src={props.logo_url}
            fallback={<FallbackCoinIcon name={props.slug || props.address} />}
          />
        ) : (
          <FallbackCoinIcon name={props.slug || props.address} />
        )}
        <div className='fragment'>
          <Text
            className='slug'
            size={18}
            style={{
              style: { width: props.isCEX ? 'auto' : '60px' },
              title: props.slug,
            }}
          >
            {props.slug}
          </Text>
          <Text
            className='full_name'
            size={12}
            style={{
              style: { width: props.isCEX ? 'auto' : '60px' },
              title: props.long_title || props.title,
            }}
          >
            {props.long_title || props.title}
          </Text>
        </div>
      </div>
      <div className='row'>
        {!props.isCEX && (
          <>
            <Text className='contract' size={12}>
              {format_contract(props.address)}
            </Text>
            <div className='img_pos' onClick={props.onCopyAddress}>
              <div className='icon icon-copy' />
            </div>
          </>
        )}
        {props.chain && (
          <div className='img_pos'>
            <div
              className='icon icon-top-right-square'
              onClick={() => onTokenScan(props.address, props.chain)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoCoin;
